import type { ProgressCounts } from './work-types';

export function progressPercent(counts: ProgressCounts | null | undefined): number {
  if (!counts || counts.total === 0) return 0;
  return Math.round((counts.done / counts.total) * 100);
}

export function progressLabel(counts: ProgressCounts): string {
  return `${counts.done}/${counts.total}`;
}

/** "1 Bug", "3 Bugs". Card type names are stream-defined, so pluralising stays naive on purpose. */
export function countLabel(count: number, name: string): string {
  return count === 1 ? `${count} ${name}` : `${count} ${name.endsWith('s') ? name : `${name}s`}`;
}
